import { render } from "./Search.vue?vue&type=template&id=676cd3c6&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=676cd3c6&scoped=true&lang=css"

import exportComponent from "/Users/kokleng/Documents/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676cd3c6"]])

export default __exports__